import React from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/pages.css';
import image1 from '../components/img/File_1.jpg';
import image2 from '../components/img/File_2.jpg';
import image3 from '../components/img/File_3.jpg';
import image4 from '../components/img/File_4.jpg';

function ImageGallery() {
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <div className='image-gallery-section'>
                <section className='image-section'>
                    <p className='page-heading'>Image Gallery</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Discover memorable moments captured at Caritas Matha 
                            <br /> 
                            Hospital in our comprehensive image gallery.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Discover memorable moments captured at Caritas Matha Hospital in our comprehensive image gallery.
                        </p>
                    </div>

                    <div className='gallery-row-1'>
                        <div className='gallery-image'>
                            <a href='#'>
                                <img className='image-card' src={image1} alt="Image 1"/>
                                <p>Care in Captures</p>
                            </a>
                        </div>

                        <div className='gallery-image'>
                            <a href='#'>    
                                <img className='image-card' src={image2} alt="Image 2"/>
                                <p>Facilities & Infrastructure</p>
                            </a>
                        </div>

                        <div className='gallery-image'>
                            <a href='#'>    
                                <img className='image-card' src={image3} alt="Image 3"/>
                                <p>Caritas College of Nursing</p>
                            </a>
                        </div>
                    </div>

                    <div className='gallery-image'>
                        <a href='#'>    
                            <img className='image-card' src={image4} alt="Image 4"/>
                            <p>Caritas College of Pharmacy</p>
                        </a>
                    </div>
                </section>

                {/* Page content ends here */}
            </div>

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default ImageGallery;